export * from './resetPasswordForm';

export const SuccessText = 'success-text';
